/**
 * Created by jonas on 2024-08-16.
 */


import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import path from "path";

export class Skinner {
    set skinId(value: string | undefined) {
        this._skinId = value;
    }
    private _skinId:string|undefined;
    private _validSkinIds:string[] = [];
    constructor(validSkinIds:string[]) {
        this._validSkinIds = validSkinIds;
    }


    public get skinId():string | undefined {
        if (this._skinId && this._skinId != ""){
            return this._skinId;
        }

        if (SlotGame.apiPlugin.options.extra) {
            let extraData;
            if (typeof SlotGame.apiPlugin.options.extra === "string") {
                extraData = JSON.parse(SlotGame.apiPlugin.options.extra);
            } else {
                extraData = SlotGame.apiPlugin.options.extra
            }

            if (extraData?.campaignId != undefined) {
                this._skinId = extraData.campaignId.toLowerCase();
            }
        }

        if (this._skinId != undefined && this._validSkinIds.indexOf(this._skinId) < 0) {
            this._skinId = undefined;
        }
        return this._skinId;
    }

    loadSkin(assetPath:string, replaceMap:Map<string, string>):Promise<any> {
        if (this.skinId != undefined){
            this.addReplaceBuyFeatureImagesListener(replaceMap);
            return this.loadAndReplaceAssets(assetPath + this.skinId, replaceMap);
        }
        return Promise.resolve();
    }

    private addReplaceBuyFeatureImagesListener(replaceMap:Map<string, string>){
        SlotGame.apiPlugin.events.on("screen", (data:string)=> {
            if (data == "open") {
                const gameInfo = document.getElementById("gameInfoContainer");
                const bonus = gameInfo?.getElementsByClassName("noLimitBonus")[0];
                if(bonus && this.skinId != undefined) {
                    const elements = bonus.getElementsByClassName("buyFeatureImage")
                    for (let element of elements){
                        const imgFileName = (<HTMLImageElement>element).alt;
                        if (element.tagName == "IMG" && replaceMap.has(imgFileName)){
                            (<HTMLImageElement>element).src = NolimitApplication.resourcePath + "/resources/images/" + this.skinId  + "/"+ imgFileName + ".png"
                        }
                    }
                }

                const booster = gameInfo?.getElementsByClassName("noLimitBooster")[0];
                if(booster && this.skinId != undefined) {
                    const elements = booster.getElementsByClassName("buyFeatureImage")
                    for (let element of elements){
                        const imgFileName = (<HTMLImageElement>element).alt;
                        if (element.tagName == "IMG" && replaceMap.has(imgFileName)){
                            (<HTMLImageElement>element).src = NolimitApplication.resourcePath + "/resources/images/" + this.skinId  + "/"+ imgFileName + ".png"
                        }
                    }
                }
            }
        });

    }

    private loadAndReplaceAssets(path:string, replaceMap:Map<string, string>):Promise<any>{
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);

        replaceMap.forEach((filename:string, id:string, key) => {
            imgLoader.add(id+"_rep", path + "/" +filename);
        });

        const promises = Promise.all([ imgLoader.load()]);
        return promises.then((values: any) => {
            replaceMap.forEach((filename:string, id:string):void => {
                id = id +"_rep"
                let baseTextureNew:PIXI.BaseTexture = PIXI.utils.BaseTextureCache[id];
                const realName = id.replace("_rep", "");
                if(PIXI.utils.TextureCache[realName]) {
                    const newTexture = PIXI.utils.TextureCache[id];
                    const texture = PIXI.utils.TextureCache[realName];
                    texture.baseTexture = baseTextureNew;
                    texture.frame = newTexture.frame;
                    texture.trim = newTexture.trim;
                    texture.trim = newTexture.trim;
                    texture.updateUvs();
                }
            })

            return Promise.resolve();
        });
    }
}